import classNames from 'classnames';
import { MouseEvent } from 'react';
import ArrowSq from '../../icons/ArrowSq';
import IconButton from '../IconButton';
import styles from './styles/styles.module.scss';

export type ArrowStyle = 'standard' | 'external' | 'extra-subtle' | 'subtle' | 'subtle-with-standard-arrows';

const subtleVariants: ArrowStyle[] = ['extra-subtle', 'subtle', 'subtle-with-standard-arrows'];

type ArrowButtonProps = {
  ariaLabel?: string;
  className?: string;
  disabled?: boolean;
  onClick: () => void;
  title: string;
  variant: ArrowStyle;
};

const variantsToClassNames: Record<ArrowStyle, string | undefined> = {
  standard: undefined,
  external: styles.external,
  'extra-subtle': styles.extraSubtle,
  subtle: styles.subtle,
  'subtle-with-standard-arrows': styles.subtleWithStandardArrows
};

const ArrowButton = (orientation: 'left' | 'right') =>
  function ({ ariaLabel, className, disabled, onClick, title, variant }: ArrowButtonProps) {
    return (
      <IconButton
        className={classNames(styles[`${orientation}Arrow`], variantsToClassNames[variant], className)}
        icon={{ Component: ArrowSq, orientation }}
        onClick={(e?: MouseEvent) => {
          e?.preventDefault();
          e?.stopPropagation();
          onClick();
        }}
        disabled={disabled}
        title={title}
        ariaLabel={ariaLabel}
        size={subtleVariants.includes(variant) ? 'sm' : 'md'}
        variant={subtleVariants.includes(variant) ? 'transparent' : 'elevated'}
      />
    );
  };

export const LeftArrow = ArrowButton('left');
export const RightArrow = ArrowButton('right');
